import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "../../../../../baseUrl";
import { createFileRoute } from "@tanstack/react-router";
import { fetchWithAuthHandling } from "../../../../../authHandling";
import { Typography, Box, Container, CircularProgress } from "@mui/material";
import { MortgageDetailsSection } from "../../../../../components/buyers/mortgage/mortgageDetailsSection";

export const Route = createFileRoute(
  "/_app/buyers/$buyerId/_buyerLayout/mortgage"
)({
  loader: ({ params }) => {
    const { buyerId } = params;
    return { buyerId };
  },
  component: mortgageTab
});

function mortgageTab() {
  const { buyerId } = Route.useLoaderData();
  const {
    data: buyerData,
    isLoading,
    error
  } = useQuery({
    queryKey: ["buyerMortgage", buyerId],
    queryFn: async () => {
      const response = await fetchWithAuthHandling(
        `${baseUrl}/buyers/${buyerId}/mortgages`,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch buyer data");
      }

      const data = await response.json();
      return data;
    }
  });

  if (!buyerData) {
    return (
      <Container
        sx={{
          my: 5,
          maxWidth: {
            xs: "97%"
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
          }}
        >
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No Mortgage Data Found
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container
      sx={{
        my: 5,
        maxWidth: {
          xs: "97%"
        }
      }}
    >
      {error && <Typography>Error loading data: {error.message}</Typography>}
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <MortgageDetailsSection mortgageDetails={buyerData} />
      )}
    </Container>
  );
}
